import { Box } from '@hivebrite/design-system/Box';
import { CardWithTitle } from '@hivebrite/design-system/Card';
import { Section } from '@hivebrite/design-system/Section';

import type { TicketItem } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import type {
  Attendee,
  EventStandardFields,
} from 'hb-react/shared/apps/Events/types';
import {
  CustomAttribute,
  Email,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

import { StandardFields } from '../StandardFields';
import { TicketAddons } from '../TicketAddons';

export const TicketForm = ({
  attendee,
  standardFields,
  ticket,
  index,
}: {
  attendee?: Attendee;
  standardFields?: EventStandardFields;
  ticket: TicketItem;
  index: number;
}) => {
  const { customizable_attributes: customizableAttributes } = ticket;

  return (
    <CardWithTitle
      title={
        <>
          {__('Ticket %{index} • ').i__({ index: `${index + 1}` })}
          {ticket.name}
        </>
      }
      data-testid="event-ticket-po"
    >
      <Box maxWidth="536px" flexDirection="column">
        <Section containerPaddingX={false}>
          <>
            <Text
              name={`attendees[${index}][firstname]`}
              label={__('First name')}
              validate={{
                required: true,
              }}
              wrapperProps={{ mb: 0 }}
            />
            <Text
              name={`attendees[${index}][lastname]`}
              label={__('Last name')}
              validate={{
                required: true,
              }}
              wrapperProps={{ mb: 0 }}
            />
            <Email
              name={`attendees[${index}][email]`}
              label={__('Email address')}
              validate={{
                required: true,
              }}
              wrapperProps={{ mb: 0 }}
            />
          </>

          <>
            {standardFields && (
              <StandardFields
                fields={standardFields}
                name={`attendees[${index}]`}
              />
            )}

            {customizableAttributes.length > 0 &&
              customizableAttributes.map((attribute) => (
                <CustomAttribute
                  key={attribute.id}
                  name={`attendees[${index}][${attribute.name}]`}
                  customAttribute={attribute}
                  // @ts-expect-error: fix types
                  labelMultiline
                  wrapperProps={{
                    mb: 0,
                    gridColumn:
                      attribute.attribute_type === 'double_select'
                        ? '1 / 3'
                        : 'auto',
                  }}
                />
              ))}
          </>
        </Section>
        {attendee && attendee.addons.length > 0 && (
          <TicketAddons addons={attendee.addons} ticketIndex={index} />
        )}
      </Box>
    </CardWithTitle>
  );
};
